<template>
    <div class="analyticsLandingPage">
        <div class="mainHeader">
            <div class="heading">
                <p class="title">Analytics</p>
            </div>
        </div>
        <div class="wrapper"> 
            <div class="headerWrapper"> 
                <div class="header"> 
                    
                    
                    <div class="rhs"> 
                        <div class="btn advReports" @click="onAdvancedReportsClick">Advanced Reports</div>
                        <div class="btn reportsBtn" @click="onSavedReportsClick">Saved Reports</div>
                        <div v-if="role == 'SUPERADMIN' || role == 'OPS'" class="btn reportsBtn" @click="onClickDefaultReports">Default Reports</div>
                    </div>
                    <div class="lhs"> 
                        <div class="dateRangeWrapper"> 
                            <div @click="onDateRangeClick" class="dateRange">{{ dateFilterType }}
                                <img class="arrowIcon" src="../assets/arrowIcon.svg" />
                            </div>
                            <div class="dateRangeContainer" v-if="showDateRangeFilter">
                                <div class="dateText" @click="onDateRangeApply('CUSTOM')">Custom</div>
                                <div v-if="showCustomDate" class="applyClass"> 
                                    <input class="dateFilter" type="date" style="margin-right: 12px; cursor: pointer;" v-model="startDate" :max="disableFutureDate">
                                    <input class="dateFilter" type="date" style="margin-right: 12px; cursor: pointer;" v-model="endDate" :max="disableFutureDate" :min="startDate">
                                    <div v-if="this.startDate && this.endDate" class="applyBtn" @click="onDateRangeApply"> Apply </div>
                                </div>
                                <div class="dateText" @click="onDateRangeApply('LAST_1D')">Last 1 day</div>
                                <div class="dateText" @click="onDateRangeApply('LAST_7D')">Last 1 week</div>
                                <div class="dateText" @click="onDateRangeApply('LAST_30D')">Last 1 month</div>
                                <div class="dateText" @click="onDateRangeApply('CURRENT_MONTH')">Current month</div>
                            </div>
                        </div>
                        <div class="filters" @click="onFiltersBtnClick">Filters <img class="icon" src="../assets/filterIcon.svg" alt=""></div>
                        <div class="filters" @click="onFieldsBtnClick">Fields <img class="icon" src="../assets/fieldsIcon.svg" alt="fields"></div>
                        <div class="btn" @click="onGenerateClick">Generate</div>
                        <div class="btn actions" @click="onActionsBtnClick">Actions</div>
                    </div>
                    <div v-if="showFields" class="fields">
                        <div class="fieldsComponent">
                            <div class="fieldsTitle">Fields</div>
                            <div class="checkboxes">
                                <div class="dimensions">
                                    <div class="subTitle">Dimensions</div>
                                    <div v-for="(checkbox, index) in dimensionsCheckboxes" :key="index">
                                        <div class="text"> 
                                            <input name="date" type="checkbox" class="checkbox" v-bind:checked="checkbox.checked" :id="'dimension-' + index" v-model="checkbox.checked">
                                            <label for="date">{{ checkbox.label.replace(/_/g, ' ').toLowerCase() }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="metrics"> 
                                    <div class="subTitle">Metrics</div>
                                    <div v-for="(checkbox, index) in metricsCheckboxes" :key="index">
                                        <div class="text"> 
                                            <input name="date" type="checkbox" class="checkbox" :id="'metric-' + index" :disabled="disableMetrics(checkbox.label.replace(/_/g, ' ').toLowerCase())" v-bind:checked="checkbox.checked" v-model="checkbox.checked">
                                            <label for="date">{{ checkbox.label.replace(/_/g, ' ').toLowerCase() }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="showFilters" class="filtersComponent">
                        <div v-for="(value, key) in filters" :key="key" > 
                            <Filters 
                                :filter="key"
                                :value="value"
                                @onFilterChange="onFilterChange"
                                :prefillValue="this.checkedFilters?.[key]"
                                :count="this.checkedFilters?.[key]?.length"
                                @onClear="onclear"
                                @onSelectAll="onSelectAll"
                            />
                        </div>
                        <div class="applyFiltersBtn" @click="onFiltersApplyClick">Apply</div>
                    </div>
                </div>
            </div>
            <div class="actionsWrapper" v-if="showActions">
                <div class="actionItem" @click="onDownloadReportClick">Download Report</div>
                <div class="actionItem" @click="onSaveAndScheduleClick">Save and schedule report</div>
            </div>
            <table class="table">
            <thead>
                <tr v-if="analyticsTableData?.length>0">
                    <th class="listItem"  v-for="(key, index) in Object.keys(analyticsTableData[0])" :key="index">
                        {{ key.replace(/_/g, ' ') }}
                    </th>
                </tr>
            </thead>
            <tbody v-if="analyticsTableData?.length > 1">
                <tr class="backgroundClass" v-for="(item, index) in tableData" :key="item?.campaign_id">
                    <template v-if="index >= 0">
                        <td class="row" v-for="(key, keyIndex) in analyticsTableData[0]" :key="keyIndex">
                            {{ (key === 'cpc' || key === 'ad_spend' || key === 'roas') ? item[key] : item[key]?.replace(/_/g, ' ') || 0 }}
                        </td>
                    </template>
                </tr>
            </tbody>
            </table>
        <div class="paginate">
            <div class="rows">
                <span class="pageinationText">Page {{currentPage}} of {{isNaN(totalPages) ? 1 : totalPages}}</span>
                <div class="flexClass"> 
                    <p class="pageinationText">Rows per page</p>
                    <select class="limit" v-model="rowsPerPage" @change="onRowsPerPageChanged">
                        <option v-for="option in options" v-bind:key="option" :value="option">{{option}}</option>
                    </select>
                    <img alt="img" v-if="currentPage > 1" @click="prevPage" class="leftArrow"
                            src="../assets/leftArrow.svg" />
                    <img alt="img" v-else class="leftArrowDisabled"
                        src="../assets/leftArrow.svg" />
                    <img alt="img" v-if="currentPage < totalPages" @click="nextPage" class="rightArrow"
                        src="../assets/rightArrow.svg" />
                    <img alt="img" v-else class="leftArrowDisabled"
                        src="../assets/rightArrow.svg" />
                </div>
            </div>
        </div>
        </div>
        <TwoFaDialog
            v-if="showOTPDialog"
            downloadReport
            @cancel="onCancelOTP"
            :reportEntityId="this.reportEntity?.reportEntityId"
        />
    </div>
</template>

<script> 
import Fields from '../components/Fields.vue'
import Filters from '../components/Filters.vue'
import DownloadDialog from './DownloadDialog.vue'
import TwoFaDialog from './TwoFaDialog.vue'
import {
    getDefaultReport,
    downloadReport,
    getFilters,
    generateReport,
    generateOtp,
    getReport,
    getCookie,
} from '../services/campaignService';
import {API_URL} from '../constants/index';
import { mapActions } from 'vuex'
import {isEmpty} from 'lodash';
import moment from 'moment';

export default {
    name: 'AnalyticsLandingPage',
    data(){
        return {
            showActions: false,
            showOTPDialog: false, 
            showFields: false,
            showFilters: false,
            analyticsTableData: [],
            tableData: [],
            dimensionFields:{},
            metricFields: {},
            reportEntity: {},
            startDate: null,
            endDate: null,
            showCustomDate: false,
            showDateRangeFilter: false,
            dateFilterType: 'Last 1 day',
            filters: {},
            checkedFilters: {},
            otpErrorMessage: '',
            showOtpError: false,
            minDate: '',

            currentPage: 1,
            rowsPerPage: 10,
            options: [10, 20, 50, 100],
            role: getCookie('role')
        }
    },
    computed: {
        totalPages() {
            let newpages = 1;
            newpages =  Math.ceil(this.reportEntity?.reportMetaData?.totalNumOfRows / this.rowsPerPage)
            newpages = Math.max(newpages, 1);
            return newpages;
        },
        disableFutureDate() {
            return  moment().subtract(1, 'days').format('YYYY-MM-DD');
        },
        dimensionsCheckboxes() {
            if(this.dimensionFields){
                return Object.keys(this.dimensionFields)?.map(key => {
                    return {
                        label: key,
                        checked: this.dimensionFields[key]
                    }
                });
            }
        },
        metricsCheckboxes() {
            if(this.metricFields){
                return Object.keys(this.metricFields)?.map(key => {
                    return {
                        label: key,
                        checked: this.metricFields[key]
                    }
                });
            }
        }
    },

    watch: {
        startDate(newVal, oldVal){
            let startDate = new Date(newVal), endDate = new Date(this.endDate)
                if(endDate < startDate){
                    this.endDate = null;
                }
        }
    },
   
    mounted() {
        const today = new Date();
        const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const minDate = currentDate > today ? currentDate : today;
        this.minDate = minDate.toISOString().split('T')[0];

        this.resetAdvanceReportBool();
        this.resetReportData();
        this.onGetDefaultReport()
        getFilters()
        .then(res => res.json())
        .then(data => {
            this.filters = data?.filters;
        });
        // localStorage.removeItem('reportData')
        // localStorage.setItem('advancedReport', false)
       
    },
    components: {
        Fields,
        Filters,
        DownloadDialog,
        TwoFaDialog
    },
    methods: {
        ...mapActions(["resetAdvanceReportBool","resetReportData"]),
        onAdvancedReportsClick() {
            this.$router.push('/advanced-reports')
        },
        disableMetrics(value){
            if(value === 'add to cart' || value === 'pdp count' || value === 'viewable impressions'){
                return true
            }
        },
        onFiltersApplyClick(){
            this.showFilters = false;
        },
        onRowsPerPageChanged(){
            this.currentPage = 1,
            this.onGetReport(this.currentPage, this.rowsPerPage)
        },
        onGetReport(page, size){
            getReport(page, size)
            .then(res=>res.json())
            .then(data=>{
                this.analyticsTableData = data?.reportData
                this.tableData = data?.reportData?.slice(1).map(item => {
                    return {
                        ...item,
                        conversion_rate: !isNaN(parseFloat(item?.conversion_rate)) && parseFloat(item?.conversion_rate) % 1 !== 0 ? parseFloat(item?.conversion_rate)?.toFixed(2) : item?.conversion_rate,
                        ctr: !isNaN(parseFloat(item?.ctr)) && parseFloat(item?.ctr) % 1 !== 0 ? parseFloat(item?.ctr)?.toFixed(2) : item?.ctr,
                        roas: !isNaN(parseFloat(item?.roas)) && parseFloat(item?.roas) % 1 !== 0 ? parseFloat(item?.roas)?.toFixed(2) : item?.roas,
                        adSpend: !isNaN(parseFloat(item?.adSpend)) && parseFloat(item?.adSpend) % 1 !== 0 ? parseFloat(item?.adSpend)?.toFixed(2) : item?.adSpend,

                    }
                })
            })
        },
        nextPage() {
            this.currentPage++
            this.onGetReport(this.currentPage, this.rowsPerPage)
        },
        prevPage() {
            this.currentPage--
            this.onGetReport(this.currentPage, this.rowsPerPage)
        },
        
        onGetDefaultReport(){
            getDefaultReport()
            .then(res => res.json())
            .then(data => {
                this.analyticsTableData = data?.reportData
                this.tableData = data?.reportData?.slice(1)?.map(item => {
                    return {
                        ...item,
                        conversion_rate: !isNaN(parseFloat(item?.conversion_rate)) && parseFloat(item?.conversion_rate) % 1 !== 0 ? parseFloat(item?.conversion_rate)?.toFixed(2) : item?.conversion_rate,
                        ctr: !isNaN(parseFloat(item?.ctr)) && parseFloat(item?.ctr) % 1 !== 0 ? parseFloat(item?.ctr)?.toFixed(2) : item?.ctr,
                        roas: !isNaN(parseFloat(item?.roas)) && parseFloat(item?.roas) % 1 !== 0 ? parseFloat(item?.roas)?.toFixed(2) : item?.roas,
                        adSpend: !isNaN(parseFloat(item?.adSpend)) && parseFloat(item?.adSpend) % 1 !== 0 ? parseFloat(item?.adSpend)?.toFixed(2) : item?.adSpend,
                    }
                })
                this.reportEntity = data?.reportEntity
                this.dimensionFields = data?.reportEntity?.dimensionFields
                this.startDate = this.reportEntity?.dateFilter?.fromDate
                this.endDate = moment.utc(this.reportEntity?.dateFilter?.toDate).subtract(1, 'days')
                data?.reportEntity ? this.onDateRangeApply(data?.reportEntity?.dateFilter?.dateFilterType) : null;
                if(this.reportEntity?.dateFilter?.dateFilterType === 'CUSTOM'){
                    this.dateFilterType = this.formatDate(this.startDate) + " - " + this.formatDate(this.endDate ? moment.utc(this.endDate).format('YYYY-MM-DD') : '') ;
                }
                this.metricFields = data?.reportEntity?.metricFields
                this.checkedFilters = data?.reportEntity?.filters ? data?.reportEntity?.filters : {}
            });
        },
        onSavedReportsClick(){
            this.$router.push(`${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/saved-reports`)
        },
        onClickDefaultReports(){
            this.$router.push(`${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/default-reports`)
        },
        formatDate(value) {
                if (value) {
                    return moment.utc(String(value)).format('YYYY-MM-DD');
                }
        },
        onActionsBtnClick() {
            this.showFields = false;
            this.showFilters = false;
            this.showActions=!this.showActions
        },
        onFieldsBtnClick(){
            this.showActions = false;
            this.showFilters = false;
            this.showDateRangeFilter=false;
            this.showFields=!this.showFields
        },
        onFiltersBtnClick(){
            this.showActions = false;
            this.showFields = false;
            this.showDateRangeFilter=false;
            this.showFilters=!this.showFilters
        },
        onDateRangeClick(){
            this.showActions = false;
            this.showFields = false;
            this.showFilters = false;
            //this.startDate = this.endDate = null;
            this.showDateRangeFilter = !this.showDateRangeFilter
        },
        dimensionsConvertData(value) {
            const dimensionsData = {};
            value?.forEach(checkbox => {
                dimensionsData[checkbox.label] = checkbox.checked;
            });
            return dimensionsData;
        },
        metricsConvertData(value) {
            const metricsData = {};
            value?.forEach(checkbox => {
                metricsData[checkbox.label] = checkbox.checked;
            });
            return metricsData;
        },
       
        onDateRangeApply(dateFilterType){
            if(dateFilterType === 'CUSTOM'){
                this.showCustomDate = true;
                return
            }
            if(dateFilterType === 'LAST_1D'){
                this.dateFilterType = 'Last 1 day';
                this.startDate = this.endDate = null;
            }else if(dateFilterType === 'LAST_7D'){
                this.dateFilterType = 'Last 1 week';
            }else if(dateFilterType ==='LAST_30D'){
                this.dateFilterType = 'Last 1 month';
            }else if(dateFilterType ==='CURRENT_MONTH'){
                this.dateFilterType = 'Current month';
            }else{
                this.dateFilterType = this.formatDate(this.startDate) + " - " + this.formatDate(this.endDate) ;
                this.startDate = this.startDate ? (moment.utc((this.startDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                this.endDate = this.endDate ? moment.utc(this.endDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : null;
            }
            this.showDateRangeFilter = false;
        },
        onclear(filterName){
            this.checkedFilters[filterName] = [];
        },
        onSelectAll(filterName, value) {
            this.checkedFilters[filterName] = [...value];
        },
        onFilterChange(data){
            if (this.checkedFilters === null) {
                    this.checkedFilters = {}; // Initialize as an empty object
                }
                if(this.checkedFilters?.hasOwnProperty(data.filterName)){
                    if(this.checkedFilters[data.filterName].includes(data.value)){
                        const updatedData = Object.fromEntries(
                                Object.entries(this.checkedFilters).map(([key, value]) => {
                                    if (key === data.filterName) {
                                        return [key, value.filter(item => item !== data.value)];
                                    }
                                        return [key, value];
                                })
                            );
                            this.checkedFilters = Object.fromEntries(
                                Object.entries(updatedData).filter(([key, value]) => value.length > 0)
                            );
                    }else{
                        this.checkedFilters[data.filterName].push(data.value)
                    }
                }else{
                    this.checkedFilters[data.filterName] = [data.value]
                }
        },
        
        onGenerateClick(){
            let value = { dimensionFields: this.dimensionsCheckboxes, metricFields: this.metricsCheckboxes }
            this.showFields = false
            this.showFilters = false

            let type;

            if(this.dateFilterType === 'Last 1 day'){
                type = 'LAST_1D';
                // this.startDate = this.endDate = null;
            }else if(this.dateFilterType === 'Last 1 week'){
                type = 'LAST_7D';
            }else if(this.dateFilterType ==='Last 1 month'){
                type = 'LAST_30D';
            }else if(this.dateFilterType ==='Current month'){
                type = 'CURRENT_MONTH';
            }else{
                type='CUSTOM'
            }

            let dateFilter = {
                'fromDate': this.startDate,
                'toDate': type !== 'CUSTOM' ? this.endDate : (moment.utc((this.endDate)).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSZ')),
                'dateFilterType': type
            }
            let params = {
                "reportEntityId": this.reportEntity?.reportEntityId,
                "reportType": "CAMPAIGN_PERFORMANCE_REPORT",
                "reportMetaData": this.reportEntity?.reportMetaData,
                "dimensionFields":  !isEmpty(value) ? this.dimensionsConvertData(value?.dimensionFields) : this.dimensionFields,
                "metricFields": !isEmpty(value) ? this.metricsConvertData(value?.metricFields) : this.metricFields,
                "filters": !isEmpty(this.checkedFilters) ? this.checkedFilters : {},
                "scheduleDetails": null,
                "isDefault": true,
                "dateFilter": !isEmpty(dateFilter) ? dateFilter : this.reportEntity?.dateFilter
            }
            generateReport(params)
            .then(res=> {
                if(res.status === 201 || res.status ===200){
                    this.onGetDefaultReport()
                    this.currentPage = 1;
                    this.rowsPerPage=10;
                }
            })
        },
        onDownloadReportClick(){
            this.showActions = false;
            this.showOTPDialog = true;
        },
        onGenerateOtp(){
            generateOtp()
        },
        // async onVerifyOTP(otp) {
        //         // OTP verification successful, proceed with the report download
        //         // if(!otp){
        //         //     this.otpErrorMessage = 'Enter a valid otp'
        //         //     return
        //         // }
        //     // await downloadReport(this.reportEntity?.reportEntityId, otp)
        //     // .then(res=>{
        //     //     if(res.status !== 200 || res.status !== 201){
        //     //         this.otpErrorMessage = 'OTP verification failed'
        //     //         localStorage.setItem('otpErrorMessage', this.otpErrorMessage)
        //     //         this.showOtpError=true;
        //     //     }else{
        //     //         this.showOTPDialog = false;
        //     //         return res.json()
        //     //     }
        //     // })
        //     // .then(data=>{
        //     //     data?.signed_urls.map(url=> {
        //     //         window.open(url);
        //     //     })
        //     // })
           
        //     // Reset the OTP dialog
        // },
        onCancelOTP() {
            this.showOTPDialog = false;
        },
        onSaveAndScheduleClick(){
            this.showActions = false;
            this.$router.push({
                path: `${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/save-schedule-report`,
            })
        },

    }
}
 
</script>

<style scoped>
    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }

    thead{
        background-color: #F6F6F6;
    }

    .actionItem{
        font-weight: 400;
        font-size: 14px;
        line-height: 23px;
        color: #41434C;
        opacity: 0.8;
        font-family: "Inter-Regular";
        cursor: pointer;
    }

    .emptyList{
        text-align: center;
        padding: 40px 0 30px;
    }

    .emptyCaseTitle{
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        text-align: center;
        color: #666666;
        margin-top: 30px;
    }

    .fields{
        position: absolute;
        right: 5px;
        top: 80px;
        z-index: 1;
    }

    .backgroundClass:nth-child(even){
        background: #F6F6F6;
    }

    .applyFiltersBtn{
        background: #FFFFFF;
        box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.08);
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #2E31BE;
        padding: 6px 12px;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        margin: 40px auto 10px;
        cursor: pointer;
    }

    .filtersComponent{
        position: absolute;
        right: 5px;
        top: 80px;
        z-index: 1;
        background: #FFFFFF;
        padding: 20px 24px;
        box-shadow: 3px 4px 9px rgba(0, 0, 0, 0.12);
    }

    .dateRangeWrapper{
        position: relative;
    }

    .dateRange {
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 210px;
        padding: 9px 18px 9px 15px;
        color: rgba(#41434C, 0.8);
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        margin-right: 12px;
        cursor: pointer;
    }

    .arrowIcon {
        width: 8px;
        height: 5px;
        margin-left: 48px;
    }

    .dateRangeContainer{
        min-width: 370px;
        position: absolute;
        top: 48px;
        z-index: 1;
        padding: 10px;
        border-radius: 4px;
        background: #FFFFFF;
        box-shadow: 3px 4px 9px rgba(0, 0, 0, 0.12);
    }

    .dateFilter{
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        padding: 8px 16px 8px 10px;
        color: #41434C;
        opacity: 0.8;
        margin-right: 12px;
        cursor: pointer;
    }

    .applyBtn{
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        color: #0004B5;
        opacity: 0.8;
        padding: 8px;
        border: 1px solid #0004B5;
        border-radius: 4px;
        cursor: pointer;
    }

    .dateText{
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        color: #41434C;
        opacity: 0.8;
        cursor: pointer;
        margin-bottom: 20px;
    }

    .dateText:last-child{
        margin-bottom: unset;
    }

    .applyClass{
        display: flex;
        margin-bottom: 10px;
    }

    .actionsWrapper{
        max-width: 206px;
        background: #FFFFFF;
        border: 1px solid #DEDEDE;
        box-shadow: 0px 4px 8px rgba(95, 95, 95, 0.24);
        padding: 10px 12px;
        border-radius: 4px;
        position: absolute;
        z-index: 1;
        right: 15px;
        top: 328px;
    }

    .actionItem:first-child{
        margin-bottom: 16px;
    }

    .rows{
        display: flex;
    }

    .date{
        width: 200px !important;
    }

    .row{
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        color: #1D1D1D;
        opacity: 0.8;
        padding: 10px 18px;
        border-right: 1px solid #D7D7D7;
        width: 140px;
    }

    .headerList{
        display: flex;
        justify-content: space-between;
        background: #F7F7F7;
        padding: 22px 12px;
    }

    .sortWrapper{
        display: flex;
        justify-content: space-between;
        background: #F0F0F0;
    }

    .sort{
        font-weight: 400;
        font-size: 10px;
        line-height: 130%;
        color: #2E31BE;
    }

    .listItem{
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 130%;
        color: #141414;
        text-transform: capitalize;
        padding: 22px 5px;
        border-right: 1px solid #D7D7D7;
        width: 140px;
    }

    .analyticsLandingPage{
        font-family: 'Inter-Regular';
        display: flex;
        flex-direction: column;
        background: #F8F8F8;
    }

    .headerWrapper{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        position: relative;
    }

    .header{
        padding: 14px 10px;
        border-radius: 4px;
        margin: 12px 16px 8px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .lhs{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .rhs{
        display: flex;
    }

    .reportsBtn{
        width: 120px !important;
    }

    .btn{
        opacity: 0.8;
        font-size: 14px;
        font-weight: 500;
        line-height: 23px;
        padding: 6px 12px;
        text-align: center;
        color: #0004B5;
        border-radius: 4px;
        width: fit-content;
        height: fit-content;
        margin-right: 24px;
        border: 1px solid #2E31BE;
        cursor: pointer;
    }

    .actions{
        margin-right: 12px;
        cursor: pointer;
        position: relative;

    }

    .filters{
        font-weight: 400;
        cursor: pointer;
        font-size: 12px;
        line-height: 23px;
        color: #41434C;
        opacity: 0.8;
        margin-right: 12px;
        border: 1px solid #E0E0E0;
        border-radius: 4px; 
        padding: 8px 12px;
        display: flex;
    }

    .icon{
        margin-left: 12px;
    }

    .paginate {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        gap: 715px;
        height: 66px;
        left: 274px;
        top: 775px;
        background: #FFFFFF;
        border: 1px solid #F8F8F8;
        width: -webkit-fill-available;
    }

    .rows {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .pageinationText{
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #9B9B9B;
    }

    .flexClass{
        display: flex;
    }

    .limit {
        display: flex;
        margin-left: 20px;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        border:  1px solid #EEEEEE;
        border-radius: 4px;
        padding: 10px 8px 10px 12px;
    }

    .leftArrow {
        display: flex;
        margin-left: 24px;
        cursor: pointer;
    }

    .leftArrowDisabled {
        display: flex;
        margin-left: 20px;
        opacity: 0.4;
        cursor: not-allowed;
    }

    .rightArrow {
        display: flex;
        margin-left: 20px;
        cursor: pointer;
    }
    .mainHeader {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        color: #401D0C;
        padding: 8px 20px 0px;
        margin-left: 0;
        background: #FFFFFF;
    }
    .title{
        margin-left:20px;
    }

    .heading {
        display: flex;
        flex-direction: row;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #333333;
        margin: 0;
    }
    .wrapper {
        display: flex;
        flex-direction: column;
        margin: 1%;
        text-align: start;
        background: #FFFFFF;
        padding: 22px 24px 36px;
        border-radius: 12px;
    }
    table {
        border-collapse: collapse;
        margin: 20px 0;
        display: block;
        overflow: scroll;
    }

    label{
        text-transform: capitalize;
    }

    .fieldsComponent{
        background: #FFFFFF;
        padding: 20px 24px;
        box-shadow: 3px 4px 9px rgba(0, 0, 0, 0.12);
    }
    .checkboxes{
        display: flex;
    }

    .dimensions{
        padding-right: 55px;
        margin-right: 16px;
    }

    .subTitle{
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 26px;
        color: #3F3F3F;
        margin-bottom: 14px;
        margin-top: 20px;
    }

    .text{
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #41434C;
        text-align: center;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    .fieldsTitle{
        font-weight: 600;
        font-size: 16px;
        line-height: 23px;
        color: rgba(0, 0, 0, 0.65);
        opacity: 0.8;
    }

</style>